export default "__VITE_ASSET__0N6AhdeP__"